const article = {
    slug: "first_sacai_experience",
    category: "BRAND ENTRY",
    title: "初めてのsacaiをレンタル体験",
    listDescription:
      "見慣れた服の構造をずらし、重ね、組み替える。sacaiを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのsacaiをレンタル体験｜異素材ミックスを着て知るEnclopedia",
      description:
        "sacaiが気になるけれど、何から見ればいいか分からない方へ。異素材切替、ドッキング、レイヤード構造など、sacaiの魅力を解説し、Enclopediaでレンタルできるアーカイブへ案内します。",
      keyword:
        "初めてのsacai,sacai 初めて,sacai レンタル,sacai 着てみたい,sacai 異素材,sacai ドッキング,sacai アーカイブ,サカイ レンタル,enclopedia,アンクロペディア",
      canonicalPath: "/archive_guide/first_sacai_experience",
    },
    hero: {
      label: "FIRST SACAI EXPERIENCE",
      number: "02 / ENTRY",
      titleLines: ["初めての", "SACAIをレンタル体験。"],
      body:
        "一見すると日常着の延長に見えるのに、\n近づくと異なる素材、用途、服の構造が一着の中で共存している。\nsacaiを初めて知るなら、まずは“着ることで分かる違い”から入るのが最も自然です。",
      keywords: [
        "first experience",
        "hybrid",
        "layering",
        "sacai",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: ["見慣れた服の中に、", "違う構造を発見する。"],
      image: "media/archive_fashion/archive_guide2.png",
      imageAlt: "初めてのsacaiをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるsacaiを見る",
      ctaHref: "https://www.enclopedia-official.com/brand/SACAI（サカイ）/?number=63",
    },
    thesis: {
      text:
        "sacaiは、見慣れた服を“混ぜる”ことで、日常着の見え方を更新するブランドです。",
      keywords: ["hybrid", "structure", "experience"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "sacaiが気になる。",
          "でも、どこが特別なのか説明しづらい。",
        ],
        body:
          "sacaiの服は、写真だけを見ると“デザインが凝っている服”に見えることがあります。\nしかし実際には、ニットとシャツ、ブルゾンとテーラード、スカートとプリーツのように、異なる服の役割を一着の中で組み替えている。\nその面白さは、着たときの立体感や動きでより明確になります。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "異素材を重ねるのではなく、",
          "服の役割を組み替える。",
        ],
        body:
          "sacaiは、日常的で見慣れた服を出発点にしながら、異なる素材や構造を接続することで、まったく新しい輪郭を作るブランドです。\nシャツ、ニット、MA-1、トレンチ、プリーツなど、誰もが知る服の要素を用いながら、その“当たり前の見え方”を静かに変えていきます。",
        knowledgeItems: [
          {
            title: "ドッキングは、装飾ではなく設計。",
            text:
              "異素材の切替は単なるアクセントではありません。前身頃と後身頃、上半身と裾、表地と裏地の役割をずらすことで、服そのものの構造を再編集しています。",
          },
          {
            title: "正面と横、動いた瞬間で印象が変わる。",
            text:
              "sacaiは、静止画よりも身体に乗ったときの見え方が重要です。横から見たボリューム、歩いたときの揺れ、重なった素材の間に生まれる奥行きが魅力になります。",
          },
          {
            title: "定番服を、定番のまま終わらせない。",
            text:
              "ミリタリー、ワーク、ニット、シャツといった身近な服を用いながら、配置や重なりを変えることで、既視感のある服を新しいものとして見せます。",
          },
          {
            title: "初めてほど、“着てみる”意味がある。",
            text:
              "sacaiの服は、写真では細部の面白さに目が向きがちです。実際に着ると、構造が身体にどう作用するかまで理解できます。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE SACAI?",
        titleLines: [
          "sacaiを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "HYBRID CONSTRUCTION",
            text:
              "異なる服の構造を一着に接続する。sacaiを理解する最も基本的な視点です。",
          },
          {
            tag: "ENTRY 02",
            title: "MATERIAL CONTRAST",
            text:
              "ニットと布帛、ミリタリーとプリーツなど、素材の緊張感によって服の表情を作ります。",
          },
          {
            tag: "ENTRY 03",
            title: "VOLUME & LAYER",
            text:
              "一枚の服の中に、レイヤードしているような奥行きを生む。横姿や動きに差が出ます。",
          },
          {
            tag: "ENTRY 04",
            title: "COLLABORATION",
            text:
              "他ブランドとの協業でも、sacaiは単なるロゴ交換ではなく、相手の服を自らの構造へ翻訳します。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "sacaiの魅力は、ディテールを読むことと、身体に乗せて構造を感じることの両方で立ち上がります。",
        items: [
          {
            index: "01",
            title: "異素材が切り替わる理由",
            text:
              "素材が違うから目立つのではなく、それぞれが異なる役割を持つことで、一着の中に複数の服の記憶が残ります。",
          },
          {
            index: "02",
            title: "静止画では見えない横顔と動き",
            text:
              "重なりや切替は、正面だけでは理解しきれません。横から見たときのふくらみ、歩いたときの揺れで、sacaiらしさが強く表れます。",
          },
          {
            index: "03",
            title: "日常着の安心感と、少しの違和感",
            text:
              "見慣れた服の要素を残しているから取り入れやすい。一方で、その構造は普通の服とは違う。この二重性がsacaiの入口になります。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "見慣れた服ほど、",
          "sacaiの編集で新しく見える。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: ["sacaiは、", "実物で理解が深まる。"],
        items: [
          {
            number: "01",
            title: "素材の厚みと落ち感が分かる",
            text:
              "異素材の組み合わせは、写真より実物で見たほうが差が明確です。重さ、張り、落ち感まで体験できます。",
          },
          {
            number: "02",
            title: "横姿とレイヤーの立ち上がりを確かめられる",
            text:
              "sacaiの魅力は、正面だけでは完結しません。横からのシルエットや動きの中で、構造がはっきり見えてきます。",
          },
          {
            number: "03",
            title: "購入前に生活との距離を測れる",
            text:
              "デザイン性が高い服ほど、自分の日常にどう入るかを試す価値があります。レンタルは、その判断材料になります。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるsacai。"],
        body:
          "実在庫への導線は、“sacaiらしさを理解する続き”として設計します。まず知り、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "sacai × WTAPS / 2025SS",
            title: "コラボレーションジャケット",
            text:
              "ワークやミリタリーの文脈を持つジャケットに、sacaiらしい構造のずれとレイヤード感を重ねた一着。",
            href: "https://www.enclopedia-official.com/product/079f1c35-7f8d-45e4-aca8-fb7da822e05b",
            image:
              "media/product/1773151184.3163898079f1c35-7f8d-45e4-aca8-fb7da822e05b.png",
          },
          {
            meta: "sacai",
            title: "異素材切替ワンピース",
            text:
              "異なる素材が同居することで、静止した状態と動いたときの見え方が変わるsacaiらしいアーカイブ。",
            href: "https://www.enclopedia-official.com/product/7d7cd289-9842-470a-a417-a43c1b7750b6",
            image:
              "media/product/1778919202.29588277d7cd289-9842-470a-a417-a43c1b7750b6.png",
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question: "sacaiは、どのアイテムから見るのがおすすめですか？",
            answer:
              "初めてなら、ニット、スカート、ジャケットなど、日常着の形式を残しながら構造の違いが見えやすいアイテムがおすすめです。",
          },
          {
            question: "写真と実物で印象はかなり変わりますか？",
            answer:
              "変わります。特に異素材切替やレイヤード構造は、厚みや横からの見え方、動いたときの揺れで印象が大きく変化します。",
          },
          {
            question: "デザイン性が強くて、着こなせるか不安です。",
            answer:
              "sacaiは見慣れた服を土台にしているため、実際に着ると意外に日常へ落とし込みやすい一着も多いです。レンタルで確認するのが合理的です。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのsacaiを、",
          "レンタルから始める。",
        ],
        body:
          "見慣れた服が、構造によって別の表情を持つ。\nその面白さを、Enclopediaで実際に体験してください。",
        buttonLabel: "レンタルできるsacaiを見る",
        buttonHref: "https://www.enclopedia-official.com/brand/SACAI（サカイ）/?number=63",
      },
    },
  };

export default article;
